module.exports = "/_next/static/images/icon-guild-income-ff8ad7ea.png";